import { TIconProps } from './utils';

export const EmailIcon = ({ className = '' }: TIconProps) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M1.88802 6.343L10.888 11.1778C11.1904 11.3398 11.5816 11.4166 11.9752 11.4166C12.3688 11.4166 12.76 11.3398 13.0624 11.1778L22.0624 6.343C22.6492 6.0274 23.2036 4.7998 22.1272 4.7998H1.82442C0.748021 4.7998 1.30242 6.0274 1.88802 6.343ZM22.3348 8.9866L13.0624 13.819C12.6544 14.0326 12.3688 14.0578 11.9752 14.0578C11.5816 14.0578 11.296 14.0326 10.888 13.819C10.48 13.6054 2.32842 9.3322 1.66242 8.9854C1.19442 8.7406 1.19922 9.0274 1.19922 9.2482V17.9998C1.19922 18.5038 1.87842 19.1998 2.39922 19.1998H21.5992C22.12 19.1998 22.7992 18.5038 22.7992 17.9998V9.2494C22.7992 9.0286 22.804 8.7418 22.3348 8.9866Z'
      fill='black'
    />
  </svg>
);
